// Per-device state in localStorage: preferences, recent places, the loop you're driving, and
// where you parked. Every access is guarded; private mode or blocked storage just means no memory.

const KEY = 'parking:'

function read(name, fallback) {
  try {
    const v = localStorage.getItem(KEY + name)
    return v ? JSON.parse(v) : fallback
  } catch {
    return fallback
  }
}
function write(name, value) {
  try {
    if (value === null || value === undefined) localStorage.removeItem(KEY + name)
    else localStorage.setItem(KEY + name, JSON.stringify(value))
  } catch {}
}

export const prefs = () => ({ dur: 120, nav: /iPhone|iPad|Macintosh/.test(navigator.userAgent) ? 'apple' : 'google', ...read('prefs', {}) })
export const savePrefs = (p) => write('prefs', { ...prefs(), ...p })

export const recentPlaces = () => read('places', [])
export function rememberPlace(place) {
  if (!place?.name || place.here) return
  const list = recentPlaces().filter((p) => !(p.name === place.name && Math.abs(p.lat - place.lat) < 1e-4))
  write('places', [{ name: place.name, detail: place.detail || '', lat: place.lat, lon: place.lon }, ...list].slice(0, 5))
}

// The loop: the plan you're driving, and which spot you're on.
export const drive = () => read('drive', null)
export const saveDrive = (d) => write('drive', d)

// Where you parked and when you have to move. Kept until you say you've left, or 3 days and 8 hours
// (past the 72-hour rule, so "Move now" still shows when that's run out).
export function parked() {
  const p = read('parked', null)
  if (p && Date.now() - p.at > 80 * 3600_000) {
    write('parked', null)
    return null
  }
  return p
}
export const saveParked = (p) => write('parked', p)
